module.exports = __webpack_public_path__ + "img/dialog_image_S205P_PX1.30c95d6f.png";